<div class="footer-wrapper">
  <span>&copy; {{ year }} </span><span [innerHTML]="copyright"></span>
</div>
